import { useState } from 'react';
import { Box, Flex, Text } from '@mantine/core';
import { TbArrowDown, TbArrowUp } from 'react-icons/tb';
import { NewTableCellWrapper } from '../cells/style';
import ReportCellComment from '../../../../components/ReportComments/ReportCellComment';
import { CELL_PADDING, FONT_SIZE, LINE_HEIGHT, TEXT_COLOR } from '../tableConstants';

// Read-only / comparison cells render plain text. For read-only fields we still
// want a comment affordance, mounted lazily on first hover (see SelectCellView).
export const ReadOnlyFundCell = ({
  id,
  value,
  isFieldChanged,
  hasChangePercent,
  changePercent,
  changeDirection,
  error,
  showComment,
  fundId,
  fundName,
  tableName,
  fieldName,
  fieldOrder
}) => {
  const [commentMounted, setCommentMounted] = useState(false);
  return (
    <NewTableCellWrapper
      id={id || `formpf-readonly-fund-cell-${fundId}-${tableName}-${fieldName}-${fieldOrder}`}
      pos="relative"
      h="100%"
      onPointerEnter={showComment ? () => setCommentMounted(true) : undefined}
    >
      <Box
        id={`${id || `formpf-readonly-fund-cell-${fundId}-${tableName}-${fieldName}-${fieldOrder}`}-body`}
        p={CELL_PADDING}
      >
        <Flex
          id={`${id || `formpf-readonly-fund-cell-${fundId}-${tableName}-${fieldName}-${fieldOrder}`}-row`}
          align="center"
          gap="8px"
        >
          <Text
            id={`${id || `formpf-readonly-fund-cell-${fundId}-${tableName}-${fieldName}-${fieldOrder}`}-value`}
            c={TEXT_COLOR}
            fz={FONT_SIZE}
            lh={LINE_HEIGHT}
            sx={{ minHeight: '100%' }}
            opacity={0.5}
          >
            {value}
          </Text>
          {isFieldChanged && (
            <>
              {hasChangePercent ? (
                <Flex align="center" gap="4px">
                  <Text
                    id={`formpf-readonly-fund-cell-change-percent-${id || `${fundId}-${tableName}-${fieldName}-${fieldOrder}`}`}
                    fz="12px"
                    c="orange.6"
                  >
                    {changePercent}%
                  </Text>
                  {changeDirection === 'up' ? (
                    <TbArrowUp fontSize="16px" color="var(--mantine-color-orange-6)" />
                  ) : changeDirection === 'down' ? (
                    <TbArrowDown fontSize="16px" color="var(--mantine-color-orange-6)" />
                  ) : null}
                </Flex>
              ) : (
                <Text
                  id={`formpf-readonly-fund-cell-changed-${id || `${fundId}-${tableName}-${fieldName}-${fieldOrder}`}`}
                  fz="12px"
                  c="orange.6"
                >
                  Changed
                </Text>
              )}
            </>
          )}
        </Flex>
        {error && (
          <Text
            id={`${id || `formpf-readonly-fund-cell-${fundId}-${tableName}-${fieldName}-${fieldOrder}`}-error`}
            fz="12px"
            mt="4px"
            c="red"
            lh="17px"
          >
            {error.msg}
          </Text>
        )}
      </Box>
      {showComment && (
        <ReportCellComment
          id={`${id || `formpf-readonly-fund-cell-${fundId}-${tableName}-${fieldName}-${fieldOrder}`}-comment`}
          fundId={fundId}
          fundName={fundName}
          tableName={tableName}
          fieldName={fieldName}
          fieldOrder={fieldOrder}
          cellHovered={commentMounted}
        />
      )}
    </NewTableCellWrapper>
  );
};
